import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_plus",
  "use": "svg_plus-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"svg_plus\"><path d=\"M5.5.328a1 1 0 0 0-1 1V4.5H1.328a1 1 0 1 0 0 2H4.5v3.171a1 1 0 1 0 2 0v-3.17H9.67a1 1 0 1 0 0-2H6.5V1.327a1 1 0 0 0-1-1Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol